export var WIDGET_ROLES = {
    RELATED_POSTS: 'wix-blog-related-posts',
    COMMENTS: 'wix-blog-comments',
};
